import { BaseLayoutFactory } from "../global/base-layout-factory";
import { PurchaseContractsProvider } from "./context/purchase-contracts-context";
import { PurchaseContractsComponent } from "./purchase-contracts-component";

export function PurchaseContractsFactory() {
    return (
        <BaseLayoutFactory>
            <PurchaseContractsProvider>
                <PurchaseContractsComponent />
            </PurchaseContractsProvider>
        </BaseLayoutFactory>
    );
}
